import { render, staticRenderFns } from "./overview-details.vue?vue&type=template&id=76560c2b&scoped=true&"
import script from "./overview-details.vue?vue&type=script&lang=js&"
export * from "./overview-details.vue?vue&type=script&lang=js&"
import style0 from "./overview-details.vue?vue&type=style&index=0&id=76560c2b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76560c2b",
  null
  
)

export default component.exports